import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=33d0a547&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=33d0a547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0a547",
  null
  
)

export default component.exports